module.exports = __webpack_public_path__ + "static/media/art22.9655f130.jpg";